<template>
  <div v-if="badge.badge_earned == false" :class="'membership-badge-item-wrap'+ (badge.badge.is_expired ? ' expired' : '')">
    <div class="badge-detail-description">
      <div class="badge-left-meta relative">
        <span v-if="badge.badge.no_of_times_repeatable && badge.badge.no_of_times_repeatable > 1 " class="badge-repeat-tag">{{ badge.no_of_times_earned ? badge.no_of_times_earned : 0 }}/{{badge.badge.no_of_times_repeatable}}</span>
        <img v-if="badge.badge && badge.badge.icon_url" :src="badge.badge.icon_url" :alt="badge.badge.desc"/>
        <img v-else src="@/assets/img/badge-icon.svg" alt="badge" />
      </div>
      <div class="badge-detail-content">
        <!-- <span class="badge-tag">EXCLUSIVE</span> -->
        <p class="is-size-14 has-text-weight-medium badge-title break-all">
          <span class="ml0 opacity-03 is-size-14 break-all">{{ badge.badge.name }}</span> 
          <span class="is-size-10px badge-start-end-date break-all" v-if="(badge.badge.is_expired || badge.badge.upcoming) && badge.badge.start_date && badge.badge.end_date">{{ readableFormat(badge.badge.start_date) }} - {{ readableFormat(badge.badge.end_date) }}</span> 
          <span v-if="!badge.badge.upcoming && exipryDateText() && !badge.badge.is_expired && badge.badge.end_date" class="badge-expiry-notice is-size-10px is-uppercase">{{ exipryDateText() }}</span></p>
        <p class="is-size-14 opacity-03 is-size-14 break-all">{{ badge.badge.desc }}</p>
        <div class="badge-progress-bar">
          <div class="progress-status-wrap" v-if="!badge.badge.is_expired">
            <span v-if="badge.badge.upcoming" class="badge-heading is-size-12 has-text-green">Coming Soon</span>
            <template v-else>
              <p><span v-if="badge.badge.badge_rewards" class="badge-heading is-size-12"> + {{ totalRewardPoints(badge.badge.badge_rewards) }}</span></p>
              <span class="status is-size-12"><strong>{{ badge.badge_threshold_progression }}</strong>/<span class="opacity-03">{{ badge.badge_threshold }}</span></span>
            </template>
          </div>
          <div class="progress-status-wrap" v-else>
            <span class="badge-heading is-size-12 has-text-red">Expired</span>
          </div>
          <progress v-if="!badge.badge.is_expired" class="progress is-small" :value="badge.badge_threshold_progression" :max="badge.badge_threshold"></progress>
          <progress v-else class="progress is-small" value="0" max="100"></progress>
        </div>
      </div>
    </div>
   
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';
import Helpers from '@/Components/Helpers/Helpers';
export default {
  data() {
    return {
    }
  },
  props: {
    badge: {
      required: true,
      type: Object,
    }
  },
  
  computed: {
    ...mapGetters({
    
    })
  },
  

  methods: {

    // Create readable date format
    readableFormat(fulldate) {
      if (_.isEmpty(fulldate)) return 'n/a';
      let receivedAt = moment(fulldate);
      return receivedAt.format('DD/MM/YYYY');
    },

    /**
     * Calculate total reward point
     */
    totalRewardPoints(rewards) {
      return Helpers.getRewardPoints(rewards);
    },

    // Badge expiry date
    exipryDateText() {
      if(this.badge.badge && !this.badge.badge.is_expired) {
        if(this.badge.badge.days_to_expire == null){
          return '';
        } else if(this.badge.badge.days_to_expire > 0) {
          let dayleft = this.badge.badge.days_to_expire > 1 ? ' days': ' day';
          return 'Expires in ' + this.badge.badge.days_to_expire + dayleft;
        } else if(this.badge.badge.days_to_expire == 0) {
          return 'Expires today';
        } else {
          return 'Expired.'
        }
      }
      return '';
    },

  },
};
</script>
